<template>
  <v-toolbar v-if="displayBool" dense class="pa-0 ma-0" :color="color"
    height="30" style="width: 100%; z-index: 9;"
    flat>
    <component :is="small ? 'h6' : 'h5'"
      v-text="$t(text)" /><v-spacer />
    <v-btn @click="config && config.notcloseable ? (null) : (displayBool = false)"
      icon x-small>
      <v-icon :size="15">mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>


<script>
export default {
  name: "JobStatusAlert",
  props: ["config"],
  components: {},

  data() {
    return {
      displayBool: true,
      color: null,
      icon: false,
      text: null,
      small: false,
    };
  },

  mounted() {
    this.showAlert();
  },

  methods: {
    showAlert() {
      this.displayBool = this.config ? true : false;
      this.color = this.config && this.config.color ? this.config.color : "primary";
      this.icon =
        this.config && this.config.icon
          ? this.config.icon
          : this.config && this.config.icon === false
            ? false
            : "mdi-alert";
      this.text = this.config && this.config.text ? this.config.text : "Alert";
      this.small = this.config && this.config.small ? this.config.small : false;
    },
  },

  computed: {},

  watch: {
    config: function () {
      this.showAlert();
    },
  },
};
</script>
